<template>
  <v-card align="center" justify="center" light min-width="21vw" max-width="30vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="d-flex align-center justify-center px-10 py-10">
      <div class="d-flex justify-center">
        <v-img class="mb-3" position="center center" :src="insight.imageUrl" max-width="100px" max-height="100px" contain/>
      </div>
      <v-divider class="mx-7" vertical/>
      <div>
        <h2 class="text-start">{{ capitalize((this.$i18n.locale === 'en')? insight.insightType : insight.insightTypeES) }}</h2>
        <p class="text-start" v-html="(this.$i18n.locale === 'en')? insight.descriptionEN : insight.descriptionES"/>
        <v-btn style="width: 100%" class="d-flex mt-7" @click="close">{{ $t('btnOk') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "InsightDetails",
  props: {
    insight: Object,
  },
  methods: {
    capitalize(string){
      string = string.toString().replaceAll('_', ' ');
      return string.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    },
    close() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Insight Details",
    "btnOk": "Ok, got it!"
  },
  "es": {
    "title": "Detalles del Insight",
    "btnOk": "¡Entendido!"
  }
}
</i18n>

<style scoped>

</style>
